import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { projectTranslations, uiStrings } from '../data/projectTranslations';

const STORAGE_KEY = 'site-language';
const supported = ['de', 'en', 'tr'];

const getInitialLanguage = () => {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (supported.includes(saved)) return saved;
  } catch (error) {
    // localStorage nicht verfügbar
  }
  return 'de';
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getInitialLanguage);

  const setLang = useCallback((next) => {
    setLangState(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch (error) {
      // ignorieren
    }
  }, []);

  const value = useMemo(() => {
    const t = (key) => uiStrings[lang]?.[key] ?? uiStrings.de[key];
    const localize = (project) => ({
      ...project,
      ...(projectTranslations[lang]?.[project.slug] || {})
    });
    return { lang, setLang, t, localize, languages: supported };
  }, [lang, setLang]);

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
